import React, { useState } from "react";
import { Card, Button, Progress } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import * as Icons from "react-icons/fa"; // Importa todos los íconos de react-icons/fa
import { CustomTable, BasicModal } from "../../../Shared";
import { CourseDetail } from "./CourseDetail";
import "./CourseCard.scss";

export function CourseCard(props) {
  const { course } = props;
  const [showModal, setShowModal] = useState(false);

  const onOpenCloseModal = () => {
    setShowModal((prevState) => !prevState);
  };

  const IconComponent =
    Icons[course?.SyllabuSubjectGrade?.Subject?.icon] || FaHome;

  return (
    <>
      <Card className="course-card" fluid>
        {/* {course.recoveryStatus && (
        <Popup
          trigger={
            <Icon
              name="check circle"
              size="large"
              style={{
                position: "absolute",
                top: "0.5rem",
                right: "0.5rem",
                zIndex: 1,
              }}
            />
          }
          content={course?.SyllabuSubjectGrade?.Subject?.name}
          position="top right"
        />
      )} */}
        <Card.Content>
          <Card.Header className="course-card__header">
            <div className="course-card__header-icon" size="large">
              {React.createElement(IconComponent)}
            </div>{" "}
            <div className="course-card__header-title">
              <div className="course-card__header-title-name">
                {course?.SyllabuSubjectGrade?.subject?.name}
              </div>
              <Card.Meta className="course-card__header-title-meta">
                Prof. {course?.teacher?.firstname} {course?.teacher?.lastname}
              </Card.Meta>
            </div>
          </Card.Header>
        </Card.Content>
        <Card.Content extra>
          <Progress
            indicating
            className="course-card__progress"
            percent={parseInt(course.progress)}
          >
            <div>Progreso del curso</div>
            <div>{parseInt(course.progress)}%</div>
          </Progress>
          <div className="course-card__actions">
            <Button
              fluid
              color="blue"
              as={Link}
              to={`/student/myCourses/${course.syllabuSubjectGradeId}`}
            >
              Ir al curso
            </Button>
            <Button fluid color="green" onClick={onOpenCloseModal}>
              Ver notas
            </Button>
          </div>
        </Card.Content>
      </Card>
      <BasicModal
        title={`Resumen académico de ${course?.SyllabuSubjectGrade?.subject?.name}`}
        show={showModal}
        close={onOpenCloseModal}
      >
        <CourseDetail course={course} onOpenCloseModal={onOpenCloseModal} />
      </BasicModal>
    </>
  );
}
